module.exports = __webpack_public_path__ + "img/soya.de9e2c30.png";